import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "card h-25 shadow" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1)
const _hoisted_7 = { class: "position-absolute bottom-0 mb-3" }

import { ref } from "vue";
import { useRouter } from 'vue-router';
import { SessionMemory } from '../../utils/SessionMemory';
import { translation } from '../../lang/Translation';

export default /*#__PURE__*/_defineComponent({
  __name: 'CancelPage',
  setup(__props) {

const router = useRouter();
const t = translation;

const back = () => {
  const backPath = SessionMemory.instance.paymentBackPage;
  router.push(backPath)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t).to("プラン変更キャンセル", "plan_change_cancel" )), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(t).to("プラン変更をキャンセルしました。","plan_change_cancel_done")), 1),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: back,
            class: "btn btn-primary btn-lg"
          }, _toDisplayString(_unref(t).to("戻る","back")), 1)
        ])
      ])
    ])
  ]))
}
}

})